"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trees = void 0;
const config_types_1 = require("../config-types");
const roles_1 = require("./roles");
// permissions branches place the CRUDs into a hierarchy
// for ease of display / access
exports.trees = [
    new config_types_1.Tree("REQUEST_SCHEDULE", [
        new config_types_1.Branch("SHIFTS_DETAILS", new config_types_1.CRUD({ c: roles_1.Role.SHIFTS_CREATE, u: roles_1.Role.SHIFTS_EDIT }), [
            new config_types_1.Branch("SHIFTS_PAY", new config_types_1.CRUD({ u: roles_1.Role.SHIFTS_PAY })),
            new config_types_1.Branch("SHIFTS_COST", new config_types_1.CRUD({ u: roles_1.Role.SHIFTS_COST })),
            new config_types_1.Branch("SHIFTS_HISTORY", new config_types_1.CRUD({ r: roles_1.Role.SHIFTS_HISTORY })),
        ]),
        new config_types_1.Branch("SHIFTS_PUBLISH", new config_types_1.CRUD({ c: roles_1.Role.SHIFTS_PUBLISH })),
        new config_types_1.Branch("SHIFTS_CANCEL", new config_types_1.CRUD({ c: roles_1.Role.SHIFTS_CANCEL })),
        new config_types_1.Branch("OVERRIDE_NONCOMPLIANCE", new config_types_1.CRUD({ u: roles_1.Role.OVERRIDE_NONCOMPLIANCE })),
        new config_types_1.Branch("BRIEFING_TEMPLATES", new config_types_1.CRUD({
            c: roles_1.Role.BRIEFING_TEMPLATES_CREATE,
            r: roles_1.Role.BRIEFING_TEMPLATES_VIEW,
            u: roles_1.Role.BRIEFING_TEMPLATES_EDIT,
        })),
        new config_types_1.Branch("VENUES", new config_types_1.CRUD({
            c: roles_1.Role.VENUES_CREATE,
            u: roles_1.Role.VENUES_EDIT,
        })),
        new config_types_1.Branch("MEMBER_POOLS", new config_types_1.CRUD({ r: roles_1.Role.MEMBER_POOLS_VIEW })),
        new config_types_1.Branch("UNIFORM_TEMPLATES", new config_types_1.CRUD({
            c: roles_1.Role.UNIFORM_TEMPLATES_CREATE,
            u: roles_1.Role.UNIFORM_TEMPLATES_EDIT,
        })),
    ]),
    new config_types_1.Tree("PROVIDE_TIMESHEETs", [
        new config_types_1.Branch("TIMESHEETS", new config_types_1.CRUD({ r: roles_1.Role.TIMESHEETS }), [
            new config_types_1.Branch("TIMESHEETS_APPROVAL", new config_types_1.CRUD({ u: roles_1.Role.TIMESHEETS_APPROVAL })),
            new config_types_1.Branch("TIMESHEETS_PRINT", new config_types_1.CRUD({ r: roles_1.Role.TIMESHEETS_PRINT })),
        ]),
        new config_types_1.Branch("VIEW_BOOKINGS", new config_types_1.CRUD({ u: roles_1.Role.SHIFTS_BOOKINGS })),
    ]),
    new config_types_1.Tree("MY_STAFF", [
        new config_types_1.Branch("MEMBERS", new config_types_1.CRUD({ r: roles_1.Role.MEMBERS_VIEW, u: roles_1.Role.MEMBERS_EDIT }), [
            new config_types_1.Branch("MEMBERS_BANK", new config_types_1.CRUD({ r: roles_1.Role.MEMBERS_BANK, u: roles_1.Role.MEMBERS_BANK_EDIT })),
            new config_types_1.Branch("MEMBERS_STATE", new config_types_1.CRUD({ r: roles_1.Role.MEMBERS_STATE, u: roles_1.Role.MEMBERS_STATE_EDIT })),
            new config_types_1.Branch("MEMBERS_PAY", new config_types_1.CRUD({ r: roles_1.Role.MEMBERS_PAY })),
            new config_types_1.Branch("MEMBERS_HISTORY", new config_types_1.CRUD({ r: roles_1.Role.MEMBERS_HISTORY })),
            new config_types_1.Branch("MEMBER_COMPLIANCE", new config_types_1.CRUD({
                r: roles_1.Role.MEMBER_COMPLIANCE,
                u: roles_1.Role.MEMBER_COMPLIANCE_EDIT,
                c: roles_1.Role.MEMBER_COMPLIANCE_CREATE,
            })),
        ]),
        new config_types_1.Branch("REPORTS_MY_STAFF", new config_types_1.CRUD({ r: roles_1.Role.REPORTS_MY_STAFF })),
    ]),
    new config_types_1.Tree("SETTINGS", [
        new config_types_1.Branch("REPORTS_PAYROLL", new config_types_1.CRUD({ r: roles_1.Role.REPORTS_PAYROLL, c: roles_1.Role.REPORTS_PAYROLL_CREATE })),
        new config_types_1.Branch("PARTNER_INFORMATION", new config_types_1.CRUD({ u: roles_1.Role.PARTNER_EDIT, r: roles_1.Role.PARTNER_VIEW })),
        new config_types_1.Branch("GENERAL_SETTINGS", new config_types_1.CRUD({ r: roles_1.Role.GENERAL_SETTINGS_VIEW })),
    ]),
    // --- example of how this will be used for a full permissions tree ---
    // new Tree("REQUEST", [
    //   new Branch(
    //     "SHIFTS",
    //     new CRUD({
    //       // c: Role.SHIFT_CREATE,
    //       // u: Role.SHIFT_EDIT
    //     }),
    //     [
    //       new Branch(
    //         "SCHEDULER",
    //         new CRUD({
    //           r: Role.SCHEDULER,
    //         })
    //       ),
    //       new Branch(
    //         "CALENDAR",
    //         new CRUD({
    //           r: Role.REQUESTER,
    //         })
    //       ),
    //       new Branch(
    //         "SHIFT_ASSIGNED",
    //         new CRUD({
    //           r: Role.SHIFT_ASSIGNED,
    //           u: Role.SHIFT_ASSIGNED_EDIT,
    //         })
    //       ),
    //       new Branch(
    //         "SHIFT_REQUESTED",
    //         new CRUD({
    //           r: Role.SHIFT_REQUESTED,
    //           u: Role.SHIFT_REQUESTED_EDIT,
    //         })
    //       ),
    //       new Branch(
    //         "SHIFT_CANCELLATIONS",
    //         new CRUD({
    //           r: Role.SHIFT_CANCELLATION,
    //           u: Role.SHIFT_CANCEL,
    //         })
    //       ),
    //     ]
    //   ),
    //   new Branch("POOLS", new CRUD({}), [
    //     new Branch(
    //       "POOLS_FAVOURITE",
    //       new CRUD({
    //         r: Role.POOLS_FAVOURITE,
    //         u: Role.POOLS_FAVOURITE_EDIT,
    //       })
    //     ),
    //     new Branch(
    //       "POOLS_UNSUITABLE",
    //       new CRUD({
    //         r: Role.POOLS_UNSUITABLE,
    //         u: Role.POOLS_UNSUITABLE_EDIT,
    //       })
    //     ),
    //     new Branch(
    //       "POOLS_GROUPS",
    //       new CRUD({
    //         c: Role.POOLS_GROUPS_CREATE,
    //         r: Role.POOLS_GROUPS,
    //         u: Role.POOLS_GROUPS_EDIT,
    //       }),
    //       [
    //         new Branch(
    //           "POOLS_GROUPS_MEMBERSHIP",
    //           new CRUD({
    //             u: Role.POOLS_GROUPS_MEMBERSHIP,
    //           })
    //         ),
    //       ]
    //     ),
    //   ]),
    //   new Branch(
    //     "BRIEFING_TEMPLATES",
    //     new CRUD({
    //       c: Role.BRIEFINGS_CREATE,
    //       r: Role.BRIEFINGS,
    //       u: Role.BRIEFINGS_EDIT,
    //     })
    //   ),
    //   new Branch(
    //     "UNIFORM_TEMPLATES",
    //     new CRUD({
    //       c: Role.UNIFORM_CREATE,
    //       r: Role.UNIFORM_TEMPLATES,
    //       u: Role.UNIFORM_TEMPLATES_EDIT,
    //     })
    //   ),
    //   new Branch(
    //     "VENUES",
    //     new CRUD({
    //       c: Role.VENUES_CREATE,
    //       r: Role.VENUES,
    //       u: Role.VENUES_EDIT,
    //     })
    //   ),
    // ]),
];
